export const supportNumber = {
  whatsApp: "551151805050",
  phone: "(11) 5180-5050",
};
